import { requestHeaderWithAccessToken, serverUrl, getStoredAuth, APIOneDriveUrl, requestHeaderForOneDrive } from "../auth/auth.service";
import { Activities, checkEctivityMailResponse } from "./activity.model";

export async function saveMailActiivityWithAttachment(Activitymodel: Activities): Promise<Activities> {
  try {
    const response = await fetch(serverUrl + `Tasks/Activities/saveemailandattachments`,
      {
        method: "POST",
        headers: requestHeaderWithAccessToken(),
        body: JSON.stringify(Activitymodel)
      }
    );
    //console.log("saveMailActiivityWithAttachment: ", await response);
    if (response.ok) return response.json();
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
export async function checkMailActiivityWithConversationId(conversationId: string): Promise<checkEctivityMailResponse> {
  try {
    const response = await fetch(serverUrl + `Tasks/Activities/checkconversation?conversationId=${conversationId}`,
      {
        method: "GET",
        headers: requestHeaderWithAccessToken(),
      }
    );
    //console.log("checkMailActiivityWithConversationId: ", await response);
    if (response.ok) return response.json();
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
export async function saveMailActiivity(Activitymodel: Activities): Promise<Activities> {
  try {
    const response = await fetch(serverUrl + `Tasks/Activities/save`,
      {
        method: "POST",
        headers: requestHeaderWithAccessToken(),
        body: JSON.stringify(Activitymodel)
      }
    );
    //console.log("updateMailActiivity: ", await response);
    if (response.ok) return response.json();
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
